import { render, staticRenderFns } from "./DocumentTypeList.vue?vue&type=template&id=a27ef3e6&scoped=true"
import script from "./DocumentTypeList.vue?vue&type=script&lang=js"
export * from "./DocumentTypeList.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypeList.vue?vue&type=style&index=0&id=a27ef3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27ef3e6",
  null
  
)

export default component.exports